<template>
    <router-link to='/admin/results'>תוצאות: חולים בעבר</router-link>
    <router-link to='/admin/results/active'>תוצאות: חולים פעילים</router-link>
</template>